import { HttpClientFactory } from './HttpClientFactory';

/* eslint-disable */
// Default Theme
const igentifyBrand = {
  "accent--alec": "#f2dedeff",
  "accent--dean": "#1f7c0fff",
  "accent--mark": "#902010ff",
  "accent--spencer": "#ca311aff",
  "accent--stanley": "#e0f4dbff",
  "accent--steve": "#3bac28ff",
  "ilus--alfred": "#b919d4ff",
  "ilus--calvin": "#4d005cff",
  "ilus--franklin": "#dcbbdeff",
  "ilus--osman": "#fffeffff",
  "ilus--peter": "#fae2ffff",
  "ilus--virginia": "#bfbebfff",
  "neutral--anne": "#ddddddff",
  "neutral--bruch": "#464647ff",
  "neutral--hugo": "#464646ff",
  "neutral--leena": "#f5f7f8ff",
  "neutral--matthew": "#868686ff",
  "neutral--ralph": "#f5f7f9ff",
  "neutral--richard": "#bfbfbfff",
  "neutral--rick": "#feffffff",
  "neutral--gabriel": "#ffffffff",
  "primary--francis": "#fae1ffff",
  "primary--george": "#6d107eff",
  "primary--mario": "#b819d4ff",
  "primary--roger": "#fbe1ffff",
  "secondary--craig": "#004f8fff",
  "secondary--eric": "#0f8aecff",
  "secondary--ruth": "#cfeaffff"
};

export interface ITheme {
  [key: string]: string;
}

export type TThemeType = 'primary' | 'secondary' | 'neutral' | 'accent' | 'illustration' | 'direction';

export type TThemeService = { [key in TThemeType]: (name: string, defaultValue?: string) => string };

export const getThemeVar = (type: TThemeType, variable?: string, defaultValue?: string): string => {
  if (typeof variable === 'undefined') {
    return getComputedStyle(document.body).getPropertyValue(`--${type}`) ?? defaultValue;
  }

  return getComputedStyle(document.body).getPropertyValue(`--${type}--${variable}`) ?? defaultValue;
};

export class ThemeService {
  themeTypes: TThemeType[] = ['primary', 'secondary', 'neutral', 'accent', 'illustration'];

  constructor(private themeName: string) {
    // eslint-disable-next-line no-constructor-return
    return new Proxy(this, {
      get: ThemeService.__get,
    });
  }

  private version = '';

  public setVersion(version: string) {
    this.version = `/${version}`;

    return this;
  }

  private get getThemeUrlByVersion() {
    return `/ui-assets/themes${this.version}/themes.json`;
  }

  public async setTheme() {
    const theme = await this.getTheme();

    this.setThemeVars(theme);
  }

  private getTheme(themeName?: string): Promise<ITheme> {
    const themeNameString = themeName ?? this.themeName;

    return HttpClientFactory.baseClient
      .get<any>(this.getThemeUrlByVersion)
      .then(res => res.data)
      .then(themes => (themes && themes[themeNameString] ? themes[themeNameString] : igentifyBrand));
  }

  public setThemeVars(theme: ITheme): void {
    Object
      .entries(theme)
      .forEach(([name, value]) => document.documentElement.style.setProperty(`--${name}`, value));
  }

  // Activates Proxy/Reflection API
  static __get(target: ThemeService, prop: string) {
    if (Reflect.has(target, prop)) {
      return Reflect.get(target, prop);
    }

    const themeTypes = Reflect.get(target, 'themeTypes');

    if (themeTypes.includes(prop)) {
      return Reflect.get(target, 'getThemeVar').bind(target, prop);
    }

    return undefined;
  }

  public getThemeVar(type: TThemeType, variable?: string, defaultValue?: string): string {
    return getThemeVar(type, variable, defaultValue);
  }
}
